import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">核心优势</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            天堂影院的四大核心优势，打造极致的高清影视在线体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-6 text-center hover:border-accent-300/40 transition-all duration-300 group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 mx-auto mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-800 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}